import { Events } from "./events.js";
import { beaconError, beaconLog, beaconWarn } from "./testing.js";
import { createRelay } from "@coveo/relay";
import { CommerceApiWrapper } from "./commerce-api-wrapper.js";
import { RelayWrapper } from "./relay-wrapper.js";
import { beaconAssert } from "./assertions.js";
import { processPage, } from "./simple-callbacks.js";
// These environment values are injected at build time by Rollup
const ORGANIZATION_SECRETS = {
    platformEndpoint: process.env.RAPTOR_PLATFORM_ENDPOINT,
    analyticsEndpoint: process.env.RAPTOR_ANALYTICS_ENDPOINT,
    organizationId: process.env.RAPTOR_ORGANIZATION_ID,
    trackingId: process.env.RAPTOR_TRACKING_ID,
    eventProtocolApiKey: process.env.RAPTOR_EVENT_PROTOCOL_API_KEY,
    searchApiKey: process.env.RAPTOR_SEARCH_API_KEY,
};
let beaconInitialized = false;
async function waitForDocumentToBeReady() {
    await new Promise((resolve) => {
        if (document.readyState == "loading") {
            document.addEventListener("DOMContentLoaded", () => {
                resolve();
            });
        }
        else {
            resolve();
        }
    });
}
export async function setupBeacon(options) {
    beaconAssert(!beaconInitialized, "Beacon is already initialized");
    beaconInitialized = true;
    await waitForDocumentToBeReady();
    if (window.navigation == null) {
        beaconWarn("Navigation not available, skipping beacon setup");
        return;
    }
    if (!ORGANIZATION_SECRETS.organizationId) {
        beaconError("No organization ID provided - did you run `npx raptor organization create`?");
        return;
    }
    beaconLog("Initializing beacon...");
    const relay = createRelay({
        token: ORGANIZATION_SECRETS.eventProtocolApiKey,
        trackingId: ORGANIZATION_SECRETS.trackingId,
        source: ["raptor-beacon@1.0.0"],
        url: `${ORGANIZATION_SECRETS.analyticsEndpoint}/rest/organizations/${ORGANIZATION_SECRETS.organizationId}/events/v1`,
    });
    const relayWrapper = new RelayWrapper(relay);
    const commerceApi = relay != null
        ? new CommerceApiWrapper(relay, {
            platformEndpoint: ORGANIZATION_SECRETS.platformEndpoint,
            organizationId: ORGANIZATION_SECRETS.organizationId,
            searchApiKey: ORGANIZATION_SECRETS.searchApiKey,
            trackingId: ORGANIZATION_SECRETS.trackingId,
            country: options.country,
            currency: options.currency,
            language: options.language,
        })
        : null;
    const events = new Events(relayWrapper, commerceApi, options.currency);
    const context = {
        events: events,
    };
    try {
        await processPage(context, options);
        beaconLog("Beacon successfully initialized!");
    }
    catch (error) {
        beaconError("Failed to initialize up beacon", error);
    }
}
//# sourceMappingURL=setup-beacon.js.map